module.exports = __webpack_public_path__ + "img/pic_light@2x.38673544.png";